export const AgreementAttachmentAcceptFileTypes = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'application/pdf',
]

export enum AttachmentMessages {
  InvalidAgreementAttachmentType = 'These attachments cannot be merged into the agreement because the file format is not compatible. Only .jpg, .jpeg, .png, .gif, and .pdf are accepted.',
}
